import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import hotkeys from 'hotkeys-js'

export default class extends Controller {
  static targets = ['modal', 'modalContainer']

  connect() {
    useClickOutside(this, { element: this.modalTarget })
    hotkeys(
      'escape',
      { scope: 'global-documents-upload' },
      () => { this.hide() },
    )
  }

  clickOutside() {
    this.hide()
  }

  hide() {
    hotkeys.setScope('all')
    this.modalContainerTarget.classList.add('hidden')
    document.querySelector('body').classList.remove('overflow-hidden')
  }

  show() {
    hotkeys.setScope('global-documents-upload')
    this.modalContainerTarget.classList.remove('hidden')
    document.querySelector('body').classList.add('overflow-hidden')
  }
}
